import { render, staticRenderFns } from "./AuthorizedLayout.vue?vue&type=template&id=347fd19c&scoped=true&"
import script from "./AuthorizedLayout.vue?vue&type=script&lang=js&"
export * from "./AuthorizedLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedLayout.vue?vue&type=style&index=0&id=347fd19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347fd19c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
